import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { isMobileMedia } from 'utils/media';
import { openModal } from 'base/actions/modal';

/**
 * This is a renderless component that does not render any markup.
 * It is responsible for determining if we should push to a modal
 * route that render the menu component as the background. Locations
 * list has a a LocationListModalManager that will manage it's own set
 * of modals.
 */
class MenuModalManager extends React.PureComponent {
  static propTypes = {
    shouldOpenMenuItemDetailModal: PropTypes.bool,
    shouldOpenOrderSettingModal: PropTypes.bool,
    shouldOpenEditCartItemModal: PropTypes.bool,
    shouldOpenCart: PropTypes.bool,
    dispatch: PropTypes.func
  };

  componentDidMount() {
    this.openModal();
  }

  openModal() {
    const {
      shouldOpenEditCartItemModal,
      shouldOpenOrderSettingModal,
      shouldOpenMenuItemDetailModal,
      shouldOpenCart,
      dispatch
    } = this.props;
    const isNotMobile = !isMobileMedia();
    if (
      (shouldOpenMenuItemDetailModal ||
        shouldOpenEditCartItemModal ||
        shouldOpenCart ||
        shouldOpenOrderSettingModal) &&
      isNotMobile
    ) {
      dispatch(openModal());
    }
  }

  render() {
    return null;
  }
}

export default connect()(MenuModalManager);
